export default __webpack_public_path__ + "static/media/button talkback-6.8dda9995.png";